import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import React from 'react';

import { getGridSpans } from '../../../stylesheets/tools/grid';
import { mq, getSpace, getColor } from '../../../stylesheets/tools';

const ReactModalAdapter = ({ className = '', modalClassName = '', ...props }) => {
  return <ReactModal className={modalClassName} portalClassName={className} {...props} />;
};

ReactModalAdapter.propTypes = {
  modalClassName: PropTypes.string,
  className: PropTypes.string
};

const StyledFloorPlan = styled(ReactModalAdapter).attrs({
  overlayClassName: {
    base: 'floorPlan__overlay',
    afterOpen: 'floorPlan__overlay--after-open',
    beforeClose: 'floorPlan__overlay--before-close'
  },
  modalClassName: 'floorPlan__content'
})`
  .floorPlan__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    pointer-events: auto;

    &:before {
      content: '';
      position: absolute;
      z-index: 1;
      right: 0;
      bottom: 0;
      width: 192px;
      height: 237px;
      background: ${getColor('lightGray')};
      clip-path: polygon(100% 0, 100% 0, 100% 100%, 16% 100%, 0 69%);
      transition:
        width 800ms ease-in-out,
        height 800ms ease-in-out;
    }

    &:after {
      content: '';
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('/static/floor-plan-background.png');
      background-repeat: no-repeat;
      background-attachment: scroll;
      background-position: center;
      background-size: cover;
      opacity: 0;
      transition: opacity 400ms ease-in-out 800ms;
    }
  }

  .floorPlan__content {
    position: relative;
    z-index: 3;
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    opacity: 0;
    transition: opacity 400ms ease-in-out 800ms;
    height: 100%;
    overflow-y: auto;
  }

  button,
  .floorPlan__content {
    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .floorPlan__close {
    position: absolute;
    top: ${getSpace('xs')};
    right: 24px;
    z-index: 100;

    ${mq('m')} {
      right: 60px;
      width: 34px;
      height: 35px;
    }

    svg {
      width: 24px;
      height: 24px;
      margin-top: 4px;

      ${mq('m')} {
        width: 34px;
        height: 35px;
        margin-top: 0;
      }
    }
  }

  .floorPlan__headline,
  .floorPlan__subline {
    position: relative;
    margin: 0;
  }

  .floorPlan__subline {
    text-transform: uppercase;
    padding-top: ${getSpace('l')};

    ${mq('m')} {
      padding-top: 0;
    }

    &--mobile-hidden {
      display: none;

      ${mq('m')} {
        display: block;
      }
    }
  }

  .floorPlan__inner-content {
    margin: ${getSpace('xs')} auto;
    text-align: center;
    ${getGridSpans('width', { s: 12, m: 10, l: 8 })};
  }

  .floorPlan__plans {
    position: relative;
    width: 100%;
    height: 0;
    margin: ${getSpace('m')} 0;
    padding-bottom: calc(568 / 679 * 100%);
    text-align: left;

    ${mq('m')} {
      margin: ${getSpace('xxxl')} 0;
    }
  }

  .floorPlan__plan-descriptions {
    margin-top: ${getSpace('xl')};
  }

  .floorPlan__overlay--after-open {
    &:before {
      width: 120vw;
      height: 180vh;
    }

    &:after,
    .floorPlan__content {
      opacity: 1;
    }
  }

  .floorPlan__overlay--before-close {
    &:before {
      transition-delay: 400ms;
      width: 192px;
      height: 237px;
    }

    &:after,
    .floorPlan__content {
      transition-delay: 0ms;
      opacity: 0;
    }
  }
`;

export default StyledFloorPlan;
